import * as types from './types';
import fetchData from '../../../shared/helpers/fetchData';
import fetchOptions from '../../../shared/helpers/fetchOptions';


const startLoading = () => ({
  type: types.IN_FLIGHT,
});

export const receiveSearchResults = searchResults => ({
  type: types.RECEIVE_SEARCH_RESULTS,
  searchResults,
});

export const fetchSearchResults = function fetchSearchResultsAction(url) {
  return function requestSearchResults(dispatch) {
    const options = fetchOptions('get');
    const handlers = {
      successHandler: receiveSearchResults,
      dispatch,
    };

    dispatch(startLoading());
    return fetchData(url, options, handlers);
  };
};
